import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

let key;
let forms = {
    'biowish_solid_acre':       'solidAcre',
    'biowish_liquid_acre':      'liquidAcre',
    'biowish_solid_hectare':    'solidHectare',
    'biowish_liquid_hectare':   'liquidHectare',
}

for(key in forms) {
    if(document.getElementById(key) !== null) {
        ReactDOM.render(
            <App calculator={forms[key]}/>,
            document.getElementById(key)
        );
    }
}



// WEBPACK FOOTER //
// ./src/index.js